export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/life-services-image1-41e608442986bbe11e423437918c0a24.png";